import ForumIcon from '@mui/icons-material/Forum';
import { Button, Grid, Theme, Typography } from '@mui/material';
import { isEqual } from 'lodash';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { contactRoutes } from '../../../routes';
import { INBOX_FILTER_INITIAL_STATE } from '../../../sic-lib/defaults';
import { useAppSelector } from '../../../store/hooks';

export default function NewRecentResultsPlaceholder() {
    const { classes } = useStyles();
    const history = useHistory();

    const inboxFilter = useAppSelector(appState => appState.inbox.filters);

    const [isSystemDefaultFilter, setIsSystemDefaultFilter] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (isEqual(INBOX_FILTER_INITIAL_STATE, inboxFilter)) {
            setIsSystemDefaultFilter(true);
        } else {
            setIsSystemDefaultFilter(false);
        }
    }, [inboxFilter]);

    const handleNavigation = () => {
        history.push(contactRoutes.setGroups(-1));
    };

    return (
        <Grid
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="50%"
        >
            <ForumIcon className={classes.icon} />
            {isSystemDefaultFilter ? (
                <Grid>
                    <Typography ml={4} marginY={1}>
                        Your inbox is empty. Conversations will appear here when you send or receive
                        a message.
                    </Typography>
                    <Typography ml={4} mb={2}>
                        Meanwhile, to start a new conversation, go to Groups &gt; All Contacts.
                    </Typography>
                    <Button onClick={handleNavigation}>Go to all Contacts</Button>
                </Grid>
            ) : (
                <Grid>
                    <Typography ml={4} marginY={1}>
                        The search did not yield any results.
                    </Typography>
                    <Typography ml={4} mb={2}>
                        Consider adjusting your parameters for a broader search and try again.
                    </Typography>
                </Grid>
            )}
        </Grid>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    icon: {
        color: theme.palette.conversationTimelinePaper.light,
        fontSize: 100,
    },
}));
